export enum Adapters {
    AWing = 'PCM2912A Audio Codec Analog Stereo',
}
